'use client'

import clsx from 'clsx'
import type { UseFormRegisterReturn } from 'react-hook-form'
import CheckboxIcon from '../CheckboxIcon'

type Props = {
	id?: string
	defaultChecked?: boolean
	disabled?: boolean
	register?: UseFormRegisterReturn
	colSpan?: string
	onChange?: (checked: boolean) => void
	checked?: boolean
}

export default function CheckboxInput({
	id,
	defaultChecked,
	register,
	checked = false,
	onChange,
	disabled = false,
	colSpan,
}: Readonly<Props>) {
	const handleChange = () => {
		if (disabled) return
		onChange?.(!checked)
	}

	return (
		<div
			data-testid="option-filter"
			className={clsx(
				'group relative flex items-center justify-center cursor-pointer border border-current w-[14px] h-[14px] mt-[5px]',
				{
					'2': '@xl:col-span-2',
				}[colSpan ?? '1']
			)}
		>
			<input
				type="checkbox"
				defaultChecked={defaultChecked}
				className="peer absolute opacity-0 cursor-pointer"
				id={id}
				disabled={disabled}
				{...register}
				onChange={handleChange}
			/>

			<CheckboxIcon
				className={clsx(
					'pointer-events-none w-2.5 transform-gpu transition-opacity duration-200 ease-in-out',
					checked || defaultChecked ? 'opacity-100' : 'opacity-0',
					disabled ? 'opacity-60' : 'stroke-current'
				)}
			/>
		</div>
	)
}
